// Configuration des documents requis par section et par type de profil
import { DocumentConfig } from '@/components/application-forms/common/DocumentUpload';

// ==================== DOCUMENTS COMMUNS ====================

export const PERSONAL_INFO_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'id-card',
    label: 'Pièce d\'identité',
    description: 'CNI, Passeport ou Titre de séjour en cours de validité',
    required: true
  },
  {
    type: 'criminal-record',
    label: 'Extrait du casier judiciaire',
    description: 'Extrait récent (ancienneté max : 3 mois)',
    required: true
  },
  {
    type: 'proof-address',
    label: 'Justificatif de domicile',
    description: 'Facture (eau, électricité, internet) de moins d\'1 mois',
    required: true
  },
  {
    type: 'first-time-owner-declaration',
    label: 'Attestation primo-accédant',
    description: 'Attestation sur l\'honneur de primo-accédant à la propriété',
    required: true
  },
  {
    type: 'photo-id',
    label: 'Photo d\'identité',
    description: 'Photo d\'identité récente',
    required: true
  }
];

export const COUPLE_DOCUMENTS: DocumentConfig[] = [
  // Documents OBLIGATOIRES
  {
    type: 'union-proof',
    label: 'Preuve d\'union',
    description: 'Acte de mariage civil, certificat de mariage religieux, témoignages pour union coutumière (3 minimum) ou preuves de vie commune pour union libre',
    required: true
  },
  {
    type: 'couple-photos',
    label: 'Photos du couple',
    description: '3-5 photos à différentes périodes montrant le couple ensemble',
    required: true
  },
  {
    type: 'solidarity-declaration',
    label: 'Déclaration d\'engagement solidaire',
    description: 'Document signé par les deux conjoints attestant leur engagement solidaire pour le paiement du loyer',
    required: true
  },
  {
    type: 'partner-id',
    label: 'Pièce d\'identité du conjoint',
    description: 'CNI, Passeport ou Titre de séjour du conjoint',
    required: true
  },

  // Documents RECOMMANDÉS - Documents familiaux
  {
    type: 'family-booklet',
    label: 'Livret de famille',
    description: 'Si vous avez des enfants ensemble',
    required: false
  },
  {
    type: 'children-birth-certificates',
    label: 'Actes de naissance des enfants',
    description: 'Actes de naissance de tous les enfants',
    required: false
  },
  {
    type: 'marriage-certificate',
    label: 'Acte de mariage',
    description: 'Acte de mariage officiel',
    required: false
  },
  {
    type: 'divorce-judgment',
    label: 'Jugement de divorce/séparation',
    description: 'Si applicable',
    required: true
  },
  {
    type: 'death-certificate',
    label: 'Certificat de décès du conjoint',
    description: 'En cas de veuvage',
    required: false
  },
  {
    type: 'shared-bills',
    label: 'Factures communes',
    description: 'Factures d\'électricité, eau ou autres services au nom des deux conjoints',
    required: false
  },
  {
    type: 'joint-bank-account',
    label: 'Compte bancaire joint',
    description: 'Relevé de compte bancaire joint (si existant)',
    required: false
  },
  {
    type: 'cohabitation-certificate',
    label: 'Attestation de vie commune',
    description: 'Attestation du chef de quartier confirmant que vous vivez ensemble',
    required: false
  }
];

// ==================== DOCUMENTS SALARIÉ ====================

export const EMPLOYMENT_INFO_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'employment-contract',
    label: 'Contrat de travail',
    description: 'Contrat en cours de validité (CDI, CDD, Intérim)',
    required: true
  },
  {
    type: 'employer-certificate',
    label: 'Attestation employeur',
    description: 'Attestation récente de votre employeur',
    required: true
  },
  {
    type: 'work-certificate',
    label: 'Certificat de travail',
    description: 'Si changement récent d\'employeur',
    required: false
  }
];

export const INCOME_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'payslips',
    label: 'Dernier Bulletin de salaire',
    description: 'le dernier bulletin de salaire',
    required: true
  },
  {
    type: 'payslips-1',
    label: 'avant dernier Bulletin de salaire',
    description: 'avant dernier Bulletin de salaire',
    required: true
  },
  {
    type: 'payslips-2',
    label: 'avant avant dernier Bulletin de salaire',
    description: 'avant avant dernier Bulletin de salaire',
    required: true
  },
  {
    type: 'bank-statements',
    label: 'Relevés bancaires',
    description: '6 derniers relevés bancaires',
    required: true
  },
  {
    type: 'rib',
    label: 'RIB',
    description: 'Relevé d\'Identité Bancaire',
    required: true
  },
  {
    type: 'tax-notice',
    label: 'Avis d\'imposition',
    description: 'Dernier avis d\'imposition sur le revenu (si applicable)',
    required: false
  }
];

export const GUARANTEES_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'guarantor-id',
    label: 'Pièce d\'identité du garant',
    description: 'Si vous avez un garant',
    required: false
  },
  {
    type: 'guarantor-payslips',
    label: 'Bulletins de salaire du garant',
    description: '3 derniers bulletins',
    required: false
  },
  {
    type: 'guarantor-tax-notice',
    label: 'Avis d\'imposition du garant',
    description: 'Dernier avis',
    required: false
  }
];

// ==================== DOCUMENTS ENTREPRENEUR ====================

export const BUSINESS_INFO_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'kbis',
    label: 'Extrait KBIS/Registre de commerce',
    description: 'Document de moins de 3 mois',
    required: true
  },
  {
    type: 'business-statutes',
    label: 'Statuts de l\'entreprise',
    description: 'Statuts à jour de votre société',
    required: false
  }
];

export const BUSINESS_FINANCIALS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'tax-declaration',
    label: 'Déclarations fiscales/Attestation fiscale',
    description: 'Liasse fiscale des 2 dernières années ou attestation fiscale',
    required: false
  },
  {
    type: 'financial-statements',
    label: 'Bilans comptables',
    description: '2 derniers bilans comptables',
    required: false
  },
  {
    type: 'bank-statements',
    label: 'Relevés bancaires professionnels',
    description: '6 derniers mois de l\'activité',
    required: false
  },
  {
    type: 'rib-professional',
    label: 'RIB professionnel',
    description: 'Relevé d\'Identité Bancaire de l\'entreprise',
    required: false
  },
  {
    type: 'accountant-certificate',
    label: 'Attestation comptable',
    description: 'Attestation de votre expert-comptable',
    required: false
  },
  {
    type: 'tax-notice',
    label: 'Avis d\'imposition personnel',
    description: 'Dernier avis d\'imposition sur le revenu',
    required: false
  }
];

export const CLIENTS_SUPPLIERS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'invoices-samples',
    label: 'Échantillons de factures',
    description: 'Quelques factures clients récentes',
    required: false
  },
  {
    type: 'contracts-samples',
    label: 'Contrats clients',
    description: 'Principaux contrats en cours',
    required: false
  }
];

export const ENTREPRENEUR_GUARANTEES_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'guarantor-id',
    label: 'Pièce d\'identité du garant',
    description: 'Si vous avez un garant personnel',
    required: false
  },
  {
    type: 'guarantor-income-proof',
    label: 'Justificatifs de revenus du garant',
    description: 'Bulletins de salaire ou avis d\'imposition',
    required: false
  }
];

// ==================== DOCUMENTS SECTEUR INFORMEL ====================

export const INFORMAL_ACTIVITY_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'activity-photos',
    label: 'Photos de l\'activité (preuves d\'activité)',
    description: 'Photos montrant votre lieu et outils de travail, factures de matériel',
    required: true
  },
  {
    type: 'location-authorization',
    label: 'Autorisation d\'occupation',
    description: 'Si vous travaillez sur un lieu fixe (marché, boutique)',
    required: false
  }
];

export const INFORMAL_INCOME_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'income-declaration',
    label: 'Attestation sur l\'honneur de revenus',
    description: 'Déclaration signée détaillant vos revenus mensuels',
    required: true
  },
  {
    type: 'cash-book',
    label: 'Cahier de recettes',
    description: 'Registre de vos ventes/recettes si vous en tenez un',
    required: false
  }
];

export const INFORMAL_CLIENTS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'client-testimonials',
    label: 'Témoignages de clients',
    description: 'Lettres ou attestations de clients réguliers',
    required: false
  },
  {
    type: 'receipts-samples',
    label: 'Échantillons de reçus',
    description: 'Quelques reçus que vous émettez',
    required: false
  },
  {
    type: 'witness-attestation',
    label: 'Attestation de 2 témoins',
    description: 'Attestations de personnes pouvant confirmer votre activité',
    required: false
  }
];

export const INFORMAL_SAVINGS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'bank-statements',
    label: 'Relevés bancaires',
    description: '6 derniers mois minimum (si vous avez un compte bancaire)',
    required: false
  },
  {
    type: 'mobile-money-statements',
    label: 'Relevés OM/Wave/Yass',
    description: '6 derniers relevés de mobile money',
    required: false
  },
  {
    type: 'rib-personal',
    label: 'RIB personnel',
    description: 'Relevé d\'Identité Bancaire',
    required: false
  },
  {
    type: 'savings-proof',
    label: 'Justificatif d\'épargne',
    description: 'Relevé de compte d\'épargne, tontine, Relevés OM/Wave/Yass, etc.',
    required: true
  }
];

export const INFORMAL_REFERENCES_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'witness-letter',
    label: 'Attestations de témoins',
    description: 'Lettres de personnes attestant de votre activité (minimum 2)',
    required: false
  },
  {
    type: 'community-letter',
    label: 'Lettre du chef de quartier/communauté',
    description: 'Attestation de votre chef de quartier ou association',
    required: false
  }
];

export const INFORMAL_PROOFS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'guarantor',
    label: 'Dossier complet du garant',
    description: 'Pièce d\'identité + justificatifs de revenus + domicile du garant',
    required: false
  },
  {
    type: 'tax-notice',
    label: 'Avis d\'imposition',
    description: 'Si vous en avez un (même "non-imposable")',
    required: false
  }
];

// ==================== DOCUMENTS COMPLÉMENTAIRES ====================

export const FINANCIAL_COMPLEMENTARY_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'additional-income',
    label: 'Revenus additionnels',
    description: 'Justificatifs d\'allocations, pensions, rentes',
    required: false
  },
  {
    type: 'savings-account',
    label: 'Compte épargne bancaire',
    description: 'Relevés de compte épargne',
    required: false
  },
  {
    type: 'tontine-attestation',
    label: 'Attestation de tontine',
    description: 'Justificatif de participation à une tontine',
    required: false
  },
  {
    type: 'savings-book',
    label: 'Livret d\'épargne',
    description: 'Relevés du livret d\'épargne',
    required: false
  },
  {
    type: 'other-savings',
    label: 'Autres formes d\'épargne locales',
    description: 'Justificatifs d\'autres systèmes d\'épargne',
    required: false
  },
  {
    type: 'current-rent-receipts',
    label: 'Quittances de loyer actuel',
    description: 'Justificatifs de paiement du loyer en cours',
    required: false
  },
  {
    type: 'loan-amortization',
    label: 'Tableaux d\'amortissement des crédits',
    description: 'Échéanciers de remboursement de prêts en cours',
    required: false
  },
  {
    type: 'alimony',
    label: 'Pensions alimentaires versées',
    description: 'Justificatifs de pensions alimentaires',
    required: false
  }
];

export const SPECIAL_SITUATIONS_DOCUMENTS: DocumentConfig[] = [
  {
    type: 'medical-certificate',
    label: 'Certificat médical (handicap)',
    description: 'Certificat attestant d\'un handicap',
    required: false
  },
  {
    type: 'disability-card',
    label: 'Carte d\'invalidité',
    description: 'Carte officielle d\'invalidité',
    required: false
  },
  {
    type: 'protection-order',
    label: 'Ordonnance de protection (violences)',
    description: 'Document légal de protection contre les violences',
    required: false
  },
  {
    type: 'accommodation-attestation',
    label: 'Attestation d\'hébergement',
    description: 'Attestation d\'hébergement actuel',
    required: false
  }
];

// ==================== MAPPING PAR TYPE DE PROFIL ====================

export const DOCUMENTS_BY_SECTION = {
  employee: {
    personal_info: PERSONAL_INFO_DOCUMENTS,
    couple_info: COUPLE_DOCUMENTS,
    employment_info: EMPLOYMENT_INFO_DOCUMENTS,
    income_info: INCOME_DOCUMENTS,
    financial_situation: [], // Pas de documents spécifiques, juste des champs de formulaire
    guarantees: GUARANTEES_DOCUMENTS,
    financial_complementary: FINANCIAL_COMPLEMENTARY_DOCUMENTS,
    special_situations: SPECIAL_SITUATIONS_DOCUMENTS
  },
  entrepreneur: {
    personal_info: PERSONAL_INFO_DOCUMENTS,
    couple_info: COUPLE_DOCUMENTS,
    business_info: BUSINESS_INFO_DOCUMENTS,
    business_financials: BUSINESS_FINANCIALS_DOCUMENTS,
    clients_suppliers: CLIENTS_SUPPLIERS_DOCUMENTS,
    entrepreneur_guarantees: ENTREPRENEUR_GUARANTEES_DOCUMENTS,
    financial_complementary: FINANCIAL_COMPLEMENTARY_DOCUMENTS,
    special_situations: SPECIAL_SITUATIONS_DOCUMENTS
  },
  informal: {
    personal_info: PERSONAL_INFO_DOCUMENTS,
    couple_info: COUPLE_DOCUMENTS,
    informal_activity: INFORMAL_ACTIVITY_DOCUMENTS,
    informal_income: INFORMAL_INCOME_DOCUMENTS,
    informal_clients: INFORMAL_CLIENTS_DOCUMENTS,
    informal_savings: INFORMAL_SAVINGS_DOCUMENTS,
    informal_references: INFORMAL_REFERENCES_DOCUMENTS,
    informal_proofs: INFORMAL_PROOFS_DOCUMENTS,
    financial_complementary: FINANCIAL_COMPLEMENTARY_DOCUMENTS,
    special_situations: SPECIAL_SITUATIONS_DOCUMENTS
  }
};

// ==================== LABELS DES SECTIONS ====================

export const SECTION_LABELS: Record<string, { title: string; description: string; icon: string }> = {
  // Sections communes
  personal_info: {
    title: 'Informations Personnelles',
    description: 'Pièces d\'identité et justificatifs de domicile',
    icon: 'FiUser'
  },
  couple_info: {
    title: 'Candidature en Couple',
    description: 'Documents relatifs au conjoint et à l\'union',
    icon: 'FiUsers'
  },
  // Sections SALARIÉ
  employment_info: {
    title: 'Situation Professionnelle',
    description: 'Contrat de travail et attestation employeur',
    icon: 'FiBriefcase'
  },
  income_info: {
    title: 'Revenus du Foyer',
    description: 'Bulletins de salaire et avis d\'imposition',
    icon: 'FiDollarSign'
  },
  guarantees: {
    title: 'Garanties',
    description: 'Documents du garant et garanties financières',
    icon: 'FiShield'
  },
  // Sections ENTREPRENEUR
  business_info: {
    title: 'Informations Entreprise',
    description: 'Documents légaux de l\'entreprise',
    icon: 'FiBriefcase'
  },
  business_financials: {
    title: 'Finances Entreprise',
    description: 'Déclarations fiscales et relevés bancaires',
    icon: 'FiTrendingUp'
  },
  clients_suppliers: {
    title: 'Clients et Fournisseurs',
    description: 'Factures et contrats commerciaux',
    icon: 'FiUsers'
  },
  entrepreneur_guarantees: {
    title: 'Garanties et Références',
    description: 'Documents des garants et références',
    icon: 'FiShield'
  },
  // Sections SECTEUR INFORMEL
  informal_activity: {
    title: 'Votre Activité',
    description: 'Photos et autorisations d\'occupation',
    icon: 'FiBriefcase'
  },
  informal_income: {
    title: 'Vos Revenus',
    description: 'Déclaration de revenus et cahier de recettes',
    icon: 'FiDollarSign'
  },
  informal_clients: {
    title: 'Vos Clients',
    description: 'Témoignages et reçus de clients',
    icon: 'FiUsers'
  },
  informal_savings: {
    title: 'Épargne et Tontines',
    description: 'Justificatifs d\'épargne et relevés',
    icon: 'FiTrendingUp'
  },
  informal_references: {
    title: 'Références',
    description: 'Attestations de témoins et du chef de quartier',
    icon: 'FiShield'
  },
  informal_proofs: {
    title: 'Preuves d\'Activité',
    description: 'Dossier du garant et justificatifs',
    icon: 'FiFileText'
  },
  // Sections COMPLÉMENTAIRES (communes à tous)
  financial_complementary: {
    title: 'Documents Financiers Complémentaires',
    description: 'Épargne, charges et revenus additionnels',
    icon: 'FiDollarSign'
  },
  special_situations: {
    title: 'Situations Particulières',
    description: 'Handicap, invalidité, protection, hébergement',
    icon: 'FiAlertCircle'
  }
};
